import styled from 'styled-components';
export const Root = styled.div `
    .userinfo{
        display: flex;
        img {
            width: 120px;
            height: 90px;
            background-color: #ededed;
            border: solid 1px #bfbfbf;
            &:not(:first-child){
                margin-left:24px;
            }
        }
    }
    .resetForm{
        .ant-form-item-control{
            line-height:20px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            &:hover{
                border-color: #FF571A;
            }
            textarea.ant-input:focus{
                box-shadow:none;
            }
            .calCount{
                float:right;
                margin-bottom:5px;
                margin-right:10px;
                color:#999999;
            }
        }
    }
`;
